import React from 'react'
import moment from "moment"
import { useEffect, useState } from "react"
import { numberFullValidate, numberValidate } from '../../../helpers/string/StringHelper'

export const useMyValidation = (value, validations, isConsiderInput, isDirty) => {
    const [isEmpty, setIsEmpty] = useState(true)
    const [emailError, setEmailError] = useState(false)
    const [digitError, setDigitError] = useState(false)
    const [numberError, setNumberError] = useState(false)

    const [isInputValid, setIsInputValid] = useState(false)

    const [errors, setErrors] = useState({
        isEmpty: '',
        isEmail: '',
        isDigit: '',
        isNumber: '',
    })

    useEffect(() => {
        let isEmpty = '',
            isEmail = '',
            isDigit = '',
            isNumber = ''

        for (const validation in validations) {
            let reg = '' // регулярка
            switch (validation) {
                case 'isEmpty':
                    if(value){
                        setIsEmpty(false)
                        isEmpty = ''
                    } else {
                        setIsEmpty(true)
                        isEmpty = 'Поле не може бути порожнім'  
                    }
                    break
                case 'isEmail':
                    reg = /^([a-zA-Z0-9_-]+\.)*[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,6}$/
                    if (reg.test(String(value).toLocaleLowerCase())) {
                        setEmailError(false)
                        isEmail = ''
                    } else {
                        setEmailError(true)
                        isEmail = 'Вкажіть коректний email'
                    }
                    break
                case 'isDigit':
                    const isValidDigit = numberValidate(value)
                    if(isValidDigit){
                        setDigitError(false)
                        isDigit = ''
                    } else {
                        setDigitError(true)
                        // isRecord = 'Запис не відповідає стандарту України'
                        isDigit = 'Тільки цифри'
                    }
                    break
                case 'isNumber':
                    const isValidNumber = numberFullValidate(value)
                    if(isValidNumber){
                        setNumberError(false)
                        isNumber = ''
                    } else {
                        setNumberError(true)
                        // isRecord = 'Запис не відповідає стандарту України'
                        isNumber = 'Тільки число'
                    }
                    break
                default:
                    break
            }
    
            setErrors({
                isEmpty,
                isEmail,
                isDigit,
                isNumber,
            })
        }

    }, [value])

    useEffect(() => {
        if (isConsiderInput) {
            setIsInputValid(true)
        } else if (
            (
                isEmpty || emailError || digitError || numberError
            )
        ) {
            setIsInputValid(false)
        } else {
            setIsInputValid(true)
        }
    }, [
        isEmpty, emailError || digitError || numberError
    ])

    return {
        isEmpty,
        emailError,
        digitError,
        numberError,

        isInputValid,
        errors
    }
}

export const useMyInput = (initialState, validations) => {
    const [value, setValue] = useState(initialState)
    const [isDirty, setIsDirty] = useState(false)
    const [isConsiderInput, setIsConsiderInput] = useState(false) // если true - не учитывается в валидации
    const valid = useMyValidation(value, validations, isConsiderInput, isDirty)

    // console.log('isConsiderInput: ' + isConsiderInput)
    const onChange = (e) => {
        setValue(e)
    }

    const onBlur = (e) => {
        setIsDirty(true)
    }

    const isConsider = (val) => {
        if (val) {
            setIsConsiderInput(true)
        } else {
            setIsConsiderInput(false)
        }
    }

    return {
        value, onChange, onBlur, isConsider, isDirty, ...valid
    }
} 